import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { useEffect, useState } from 'react';
import Home from '../Pages/Home';
import './MainHeader.css'


const MainHeader = ({ parentFunction }) => {
    const [isMobileMenu, setIsMobileMenu] = useState(false);

    parentFunction(isMobileMenu);


    const userData = JSON.parse(sessionStorage.getItem("UserData"));
    const userName = userData.name;

    const isPc = useMediaQuery({
        query: "(min-width: 768px)"
    });

    const navigate = useNavigate();



    return (
            <div className='header'>
                    <div className='headerTop'>
                        {isPc ? <div className="title" onClick={() => navigate("/Home")}>
                            <img src="main.png" />
                        </div> : <div className="title" onClick={() => navigate("/Home")}>
                            MILE STONE
                        </div>}

                        {isPc ? 
                        <nav className='mainMenu'>
                            <ul>
                            <li className='menu-item' onClick={() => navigate("/Home")}>
                                <a>Main</a>
                            </li>
                            <li onClick={() => navigate("/Profile")} className='menu-item' >
                                <a>Profile</a>
                            </li >
                            <li onClick={() => { navigate("/Location") }} className='menu-item'>
                                <a>Location</a>
                            </li>
                            <li onClick={() => { navigate("/Award") }} className='menu-item'>
                                <a>Award</a>
                            </li>
                            <li onClick={() => { navigate("/Rank") }} className='menu-item'>
                                <a>LeaderBoard</a>
                            </li>
                            {/* <li onClick={() => { navigate("/Board") }} className='menu-item'>
                                <a>Board</a>
                            </li> */}
                        </ul>
                        </nav> : null}

                        <div className='name'>
                        <div className='WelcomeName'>Welcome <br/>{userName}</div>
                            {isPc ? <img src={userData.profile} /> : null}
                        </div>
                        {isPc ? null : <div className='menuButton' onClick={() => setIsMobileMenu(!isMobileMenu)}>Ξ</div>}
                    </div>

                    {isMobileMenu ? <div className='mobile-menu__background'>
                        <ul className='mobile-menu'>
                            <p onClick={() => navigate("/Profile")} className='mobile-menu-item'>
                                <a>Profile</a>
                            </p >
                            <p onClick={() => { navigate("/Location") }} className='mobile-menu-item'>
                                <a>Location</a>
                            </p>
                            <p onClick={() => { navigate("/Award") }} className='mobile-menu-item'>
                                <a>Award</a>
                            </p>
                            {/* <p onClick={() => { navigate("/Board") }} className='mobile-menu-item'>
                                <a>Board</a>
                            </p> */}
                            <p onClick={() => { navigate("/Rank") }} className='mobile-menu-item'>
                                <a>Rank</a>
                            </p>

                        </ul> </div> : null}
            </div>
    )
}

export default MainHeader;